import { useEffect, useState } from "react";
import { Button, Form, Input, Modal, Space, Flex, Select, message, Checkbox, Typography } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { setFormType } from "../../../../redux/slices/roleUserSlice";
import { showLoader } from "../../../../utils/showloader";
import { createUser } from "../../../../services/adminServices";
import { trimStringValues } from "../../../../utils/trimStrings";
import { ArrowLeftOutlined } from "@ant-design/icons";

const formItemLayout = {
    labelCol: { span: 6 },
    wrapperCol: { span: 18 }, // Adjust the span for width
};

const AddEditUser = (props) => {
    const { selectedUser, setSubmitUser, showForm, submitUser, reloadTable, setShowForm, groups=[] } = props
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const [form] = Form.useForm();
    const { formType } = useSelector(state => state.roleUser);


    useEffect(() => {
        if (submitUser) {
            form.submit()
        }
    }, [submitUser])

    useEffect(() => {
        form.resetFields();
    }, [])

    useEffect(() => {
        if (selectedUser) {
            // Split the name into firstName and lastName for editing
            const nameParts = selectedUser.name ? selectedUser.name.split(' ') : ['', ''];
            const firstName = nameParts[0] || '';
            const lastName = nameParts.slice(1).join(' ') || '';
            
            form.setFieldsValue({ 
                ...selectedUser, 
                firstName,
                lastName
            })
        } else {
            form.resetFields()
        }
    }, [selectedUser, form])

    const onSaveUser = async (values) => {
        let postData = { ...values, groupIds: values.groupIds || [] }
        if (selectedUser && selectedUser.userId) {
            postData.userId = selectedUser.userId
        }
        showLoader(true)
        let userResp = await createUser(postData)
        showLoader(false)
        setSubmitUser(false)
        if (userResp.status === 200) {
            message.success(userResp.message);
            dispatch(setFormType(""))
            setShowForm(false)
            reloadTable();
        } else {
            message.error(userResp.message)
        }

    }
    const saveUserForm = async (values) => {
        try {
            await form.validateFields();
            values = trimStringValues(values);
            // Concatenate firstName and lastName to create name
            const processedValues = {
                ...values,
                name: `${values.firstName} ${values.lastName}`.trim(),
                employeeId: values.employeeId || "",
                defaultLanguage: "english"
            };
            // Remove firstName and lastName from the payload since we're sending name
            delete processedValues.firstName;
            delete processedValues.lastName;
            onSaveUser(processedValues)
        } catch (errorInfo) {
        }
    }

    const goBack = () => {
        dispatch(setFormType(""))
            setShowForm(false)

    }



    return (
        <>
            <Typography.Title level={4} className="p-0 m-0" >
          <span><ArrowLeftOutlined className="cursor-pointer" style={{ marginRight: "12px" }} onClick={goBack}  />{selectedUser ? t("Update User") : t("Add User")}</span>

            </Typography.Title>

            <Form form={form} onFinish={saveUserForm} layout="vertical" {...formItemLayout}>
                <Flex gap={16} style={{ width: "75%" }}>
                    <Form.Item label={t("First Name")} name="firstName" rules={[{ required: true, whitespace: true, message: t("First name is required") }]} labelCol={{
                        span: 24,
                    }}
                        wrapperCol={{
                            span: 24,
                        }} style={{ flexGrow: "1" }}>
                        <Input placeholder={t("Enter first name")} />
                    </Form.Item>
                    <Form.Item label={t("Last Name")} name="lastName" rules={[{ required: true, whitespace: true, message: t("Last name is required") }]} labelCol={{
                        span: 24,
                    }}
                        wrapperCol={{
                            span: 24,
                        }} style={{ flexGrow: "1" }}>
                        <Input placeholder={t("Enter last name")} />
                    </Form.Item>
                </Flex>
                <Flex gap={16} style={{ width: "75%" }}>
                    <Form.Item label={t("Email ID")} name="email" rules={[{ required: true, whitespace: true, message: t("Email ID is required") }]} labelCol={{
                        span: 24,
                    }}
                        wrapperCol={{
                            span: 24,
                        }} style={{ flexGrow: "1" }}>
                        <Input placeholder={t("Enter email id")} />
                    </Form.Item>
                    <Form.Item label={t("Employee ID")} name="employeeId" rules={[{ message: t("Employee ID is required") }]} labelCol={{
                        span: 24,
                    }}
                        wrapperCol={{
                            span: 24,
                        }} style={{ flexGrow: "1" }}>
                        <Input placeholder={t("Enter employee id")} />
                    </Form.Item>
                </Flex>

                <Form.Item label={t("Description")} name="description">
                    <Input placeholder={t("description")} />
                </Form.Item>
                <Form.Item label={t("Add user to group")} name="groupIds" >
                    <Select mode="multiple" options={groups.map(group => {
                        return {label: group.name, value: group.groupId}
                    })} placeholder={t("Select group")} />
                </Form.Item>
                <Form.Item label="" name="isAdmin" valuePropName="checked" layout="horizontal" >
                    <Checkbox>{t("Is this user an admin?")}</Checkbox>
                </Form.Item>
            </Form>
        </>
    )
}

export default AddEditUser